import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import { Icon } from "../../../Components/Icon";
import { FlexSpacer, Gap20 } from "../../../react/components/Gap";
import { themeColors } from "../../../react/sharedStyles";
import { BeautifulDialog, DialogContent, ShowDialog } from "../../../react/components/Dialogs/BaseDialog";
import { DialogActions, DialogTitle } from "@material-ui/core";

import { Button } from "../../../Components/Button";
import { TextField } from "../../../Components/TextField";
import { Checkbox } from "@material-ui/core";
import { WithLabel } from "../../../Components/WithLabel";
import { trackActivity } from "../../../core/utilities/utilities";
import SlideAiController from "./SlideAiController";

const Container = styled.div`
    color: white;
    font-weight: bold;
    //height: 20px;
    padding: 10px 20px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    
    .thumbsup {
        .bai-icon {
            &:hover {
                color: limegreen !important;
            }
        }
    }
    .thumbsdown {
        .bai-icon {
            &:hover {
                color: orangered !important;
            }
        }
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;

const ThanksContainer = styled(Container)`
    animation: ${fadeOut} 3s ease-in;
`;

export class SlideAiFeedbackWidget extends Component {
    state = {
        responded: false,
    }

    handleThumbsUp = () => {
        const { prompt, currentSlide } = this.props;
        trackActivity("SlideAi", "Feedback", null, null, {
            value: true,
            prompt
        });

        this.setState({ responded: true });
        setTimeout(() => {
            currentSlide.updateMetadata({ gotUserFeedback: true });
        }, 3000);
    }

    handleThumbsDown = () => {
        const { prompt, currentSlide } = this.props;
        currentSlide.updateMetadata({ gotUserFeedback: true });
        ShowDialog(BadFeedbackDialog, { prompt, currentSlide });
    }

    handleClose = () => {
        const { currentSlide } = this.props;
        currentSlide.updateMetadata({ gotUserFeedback: true });
    }

    render() {
        const { responded } = this.state;

        if (responded) {
            return (
                <ThanksContainer>
                    <Icon fill color={themeColors.aiColor}>favorite</Icon>
                    Thank you for your feedback!
                </ThanksContainer>
            );
        }

        return (
            <Container>
                Happy with the results?
                <Icon className="thumbsup" fill color="#ccc" onClick={this.handleThumbsUp}>thumb_up</Icon>
                <Icon className="thumbsdown" fill color="#ccc" onClick={this.handleThumbsDown}>thumb_down</Icon>
                <FlexSpacer />
                <Icon color="#ccc" onClick={this.handleClose}>close</Icon>
            </Container>
        );
    }
}

const FeedbackTextField = styled(TextField)`
    .MuiInputBase-root {
        padding: 10px;
    }
`;

class BadFeedbackDialog extends Component {
    state = {
        sharePrompt: true,
        feedback: ""
    }

    handleClose = sendFeedback => {
        const { closeDialog, prompt } = this.props;

        console.log("Submitting bad feedback:", sendFeedback, this.state.feedback);
        trackActivity("SlideAi", "Feedback", null, null, {
            value: false,
            feedback: sendFeedback ? this.state.feedback : null,
            prompt
        });
        closeDialog();
    }

    render() {
        // const { sharePrompt } = this.state;
        const { closeDialog } = this.props;

        return (
            <BeautifulDialog maxWidth="sm" onClose={this.handleClose}>
                <DialogTitle>We'd love any feedback to help us improve!</DialogTitle>
                <div style={{ padding: "0px 20px" }}>
                    <FeedbackTextField variant="outlined" multiline
                        rows={10} fullWidth
                        placeholder="What went wrong? What could be improved?"
                        value={this.state.feedback}
                        onChange={feedback => this.setState({ feedback })}
                    />
                </div>
                <DialogActions>
                    {/*<WithLabel tight right label="Share your prompt with Beautiful.ai">*/}
                    {/*    <Checkbox*/}
                    {/*        size="small"*/}
                    {/*        color="primary"*/}
                    {/*        style={{ padding: 0 }}*/}
                    {/*        checked={sharePrompt}*/}
                    {/*        onChange={e => {*/}
                    {/*            this.setState({ sharePrompt: e.target.checked });*/}
                    {/*        }}*/}
                    {/*    />*/}

                    {/*</WithLabel>*/}
                    <FlexSpacer />
                    <Button unframed onClick={() => this.handleClose(false)}>Cancel</Button>
                    <Button onClick={() => this.handleClose(true)}>Submit Feedback</Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}

